import AspectRatio from '@blocks/AspectRatio'
import Grid from '@blocks/Grid'
import Stars from '@jury/components/blocks/Stars'
import React, { useState } from 'react'
import LazyLoad from 'react-lazyload'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '@shared/redux/store'
import styled from 'styled-components'
import { useSalonNominationsContext } from '../../context'
import { voteNomination } from '../../redux/nominations.slice'

function SalonNomination({ data: nomination, idx }: Props) {
    const dispatch = useDispatch()
    const tempVotes = useSelector<RootState, RootState["nominations"]["tempVotes"]>(state => state.nominations.tempVotes)
    const { gallery } = useSalonNominationsContext()

    const castVote = async (score: number) => {
        dispatch(voteNomination({ id: nomination.id, score }))
    }

    return (
        <LazyLoad height="200px" once={true} offset={100}>
            <Grid gap="10px">
                <AspectRatio height={nomination.photo.height} width={nomination.photo.width}>
                    <ImageWrapper>
                        <ImageContainer src={nomination.photo.url} onClick={() => gallery.open(idx)} />
                    </ImageWrapper>
                </AspectRatio>
                <Grid gap="5px">
                    <h4>{nomination.photo.title}</h4>
                    <small>{nomination.section.name}</small>
                </Grid>
                <Stars score={tempVotes[nomination.id] || nomination.vote?.score} cast={castVote} />
            </Grid>
        </LazyLoad>
    )
}

export default React.memo(SalonNomination)

// STYLES
const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`

const ImageContainer = styled.div<{ src: string, onClick?: any }>`
    position: relative;
    width: 100%;
    height: 100%;
    background: ${({ src }) => `url(${src}) center center no-repeat`};
    background-size: cover;
    border-radius: 5px;
    cursor: ${props => props.onClick ? "zoom-in" : "auto"};
    transition: .2s ease-out;

    &:hover {
        transform: scale(1.02);
    }
`

interface Props {
    data: Jury.Resources.Nomination
    idx: number
}